import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
export var useOrderItemCardGrid = function useOrderItemCardGrid() {
  var itemsPerRow = useResponsiveValue({
    mobileAndAbove: 1,
    tabletAndAbove: 2
  });
  var gap = useResponsiveValue({
    mobileAndAbove: "2x",
    desktopAndAbove: "3x"
  });
  return {
    itemsPerRow: itemsPerRow,
    gap: gap
  };
};